<template>
  <app-card
    class="flex flex-col"
    :status="
      project.terminated_at
        ? 'negative'
        : project.all_contracts_signed
          ? 'base'
          : 'neutral'
    "
  >
    <div class="flex flex-1">
      <div class="flex-1 h-full mb-4 px-4 pt-4 pb-2">
        <h3 class="mt-1 mb-0 leading-tight">
          {{ project.title }}
        </h3>
        <p class="text-grey-600">
          <small>{{ project.competition.title }}</small>
        </p>
      </div>
      <card-actions class="mr-6 mt-5">
        <ul class="list-reset text-sm text-center">
          <li
            v-for="(action, index) in actions"
            :key="action.route"
            class="p-2"
            :class="{ 'border-b': index + 1 !== actions.length }"
          >
            <a
              class="block no-underline hover:text-primary-800 text-black"
              :href="route(action.route, project.uuid)"
            >
              {{ action.name }}
            </a>
          </li>
        </ul>
      </card-actions>
    </div>
    <div class="px-4 pb-6">
      <p
        v-if="project.terminated_at"
        class="mb-4 text-sm text-negative-700 italic"
      >
        This project has been terminated.
      </p>
      <p
        v-if="!project.terminated_at && !project.all_contracts_signed"
        class="mb-4 text-sm text-neutral-700 italic"
      >
        Contracting action required.
      </p>
      <h4 class="text-2xs uppercase tracking-tight text-grey-800">
        {{
          project.contracts.length ? "Total Project Grant" : "Awaiting Contract"
        }}
      </h4>
      <p
        v-if="project.contracts.length"
        class="text-3xl font-bold leading-none"
        :class="
          project.terminated_at ? 'text-negative-700' : 'text-primary-700'
        "
      >
        {{ totalGrant }}
      </p>
      <p
        v-else
        class="text-md text-primary-700 font-bold leading-tight"
      >
        Your contract will be sent via email in due course
      </p>
    </div>
    <div class="border-t bg-grey-100 p-4">
      <p class="text-xs text-grey-700">
        <icon
          icon="calendar"
          class="icons-grey w-4 h-4 mb-0 align-text-bottom mr-1"
        />
        {{ endDate }}
      </p>
    </div>
  </app-card>
</template>

<script>
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
export default {
  name: "UserProjectCard",
  props: {
    project: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    endDate() {
      return format(
        parseISO(this.project.competition.end_date),
        "do MMMM yyyy"
      );
    },
    totalGrant() {
      return this.project.contracts
        .reduce((total, { grant }) => {
          total += grant;
          return total;
        }, 0)
        .toLocaleString("en-GB", { style: "currency", currency: "GBP" });
    },
    actions() {
      let actionsArray = [];

      // Overview
      if (this.project.contracts.length) {
        actionsArray.push({
          name: "Overview",
          route: "projects.view"
        });

        // Team
        actionsArray.push({
          name: "Team",
          route: "projects.team.index"
        });

        // Requests
        if (this.user.is_monitor == 0) {
          actionsArray.push({
            name: "Requests",
            route: "projects.request.index"
          });
        }

        // Claims
        if (this.user.is_monitor == 0) {
          actionsArray.push({
            name: "Claims",
            route: "projects.claim.index"
          });
        }

        // Contracts
        actionsArray.push({
          name: "Contracts",
          route: "projects.contracts.index"
        });
      }

      // Application
      actionsArray.push({
        name: "Application",
        route: "applications.view"
      });

      return actionsArray;
    }
  },
  methods: {}
};
</script>
